import * as React from "react";
import { FunctionComponent } from "react";

// A page: the header, then the page's content.
const PageContainer: FunctionComponent = ({ children }) => <div className="page">{children}</div>;

export default PageContainer;
